
<template>
  <v-app class="grey lighten-4">
    <PublicNavbar v-if="!SignedIn && !FocusedView && !IntranetView"/>
    <IntranetNavbar @IntranetViewToggle="IntranetViewToggle" @DeactivateSearch="DeactivateSearch" @ActivateSearch="ActivateSearch" :UserRecord="UserRecord" v-if="SignedIn && !FocusedView && IntranetView"/>
    <Navbar @IntranetViewToggle="IntranetViewToggle"  v-if="SignedIn && !FocusedView && !IntranetView"/>
    <BreadCrumbs v-if="SignedIn && !FocusedView && !IntranetView" class="breadcrumbstop" />
    <v-card flat color="background"  height="100%" v-if="!IntranetView && !SearchView">
      <router-view :UserRecord="UserRecord" @IntranetViewToggle="IntranetViewToggle" @FocusedViewToggle="FocusedViewToggle" class="footermargin"></router-view>
    </v-card>
    <v-card flat color="background"   height="100%"  v-if="IntranetView && !SearchView">
      <router-view :UserRecord="UserRecord" @IntranetViewToggle="IntranetViewToggle" @FocusedViewToggle="FocusedViewToggle" class="footermargin"></router-view>
    </v-card>
    <v-card flat color="background" height="100%" v-if="IntranetView && !SearchView">
      <router-view :UserRecord="UserRecord" @IntranetViewToggle="IntranetViewToggle" @FocusedViewToggle="FocusedViewToggle" class="footermargin"></router-view>
    </v-card>
    <SearchComponent :UserRecord="UserRecord" v-if="SearchView" :ActiveSearch="ActiveSearch" />
    <v-footer
      :dark="true"
      fixed
      app
      height="50px"
    >
      <span><span>Tribunes</span><span class="font-weight-light"> SA </span>© 2020</span><v-spacer></v-spacer>
      Registered with the NCR
      <!-- <v-avatar tile size="50"><v-img height="40px" contain src="@/assets/NCR_Logo.jpeg"/></v-avatar> -->
      <v-spacer></v-spacer>
      <span>Powered by</span><pre> </pre><a href="https://www.rapidapps.co.za/" style="color:white" target="_blank" class="txtlink">Rapid<span class="font-weight-light">Apps™</span></a>
    </v-footer>
  </v-app>
</template>
<script>
import db from '@/main'
import Navbar from './components/Navbar'
import IntranetNavbar from './components/IntranetNavbar'
import PublicNavbar from './components/PublicNavbar'
import firebase from 'firebase';
import BreadCrumbs from './components/BreadCrumbs'
import SearchComponent from './components/SystemNavigation/SearchComponent'
export default {
  components: { SearchComponent,Navbar,BreadCrumbs,PublicNavbar,IntranetNavbar },
  name: 'App',
  data () {
    return {
      SignedIn: true,
      FocusedView: false,
      IntranetView: false,
      UserRecord: {},
      SearchView: false,
    }
  },
  created(){
    this.CheckAuth()
    window.addEventListener('scroll', this.handleScrollRecordToolbar)
    //<!-- window.onload = this.RecordBannerParallax() -->
  },
  methods: {
    ActivateSearch(search){
      console.log('yep I activate search view')
      console.log(search)
      this.SearchView = true
      this.ActiveSearch = search
      console.log(this.SearchView)
      console.log(this.ActiveSearch)
    },
    DeactivateSearch(){
      console.log('yep I deactivate or try to')
      this.SearchView = false
      this.ActiveSearch = ''
    },
    FocusedViewToggle(boolean){
        this.FocusedView = boolean    
    },
    IntranetViewToggle(boolean){
        this.IntranetView = boolean    
    },
    RecordBannerParallax(){
      setTimeout(() => {
      var recordbanner = document.getElementById("recordbanner");
      var recordparallax = document.getElementById("recordparallax");
      console.log('recordbanner',recordbanner)
      console.log('recordparallax',recordparallax)
      if(!recordbanner && recordparallax){
          recordparallax.style.top = '110px'
        }
        }, 500);
    },
    handleScrollRecordToolbar(event) {
      var recordtoolbar = document.getElementById("recordtoolbar");
      var recordtoolbar2 = document.getElementById("recordtoolbar2");
      var recordownershipbanner1 = document.getElementById("recordownershipbanner1");
      var recordownershipbanner2 = document.getElementById("recordownershipbanner2");
      let logobar = document.getElementById('logobar')
      let belowlogobar = document.getElementById('belowlogobar')
      if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
        if(logobar && belowlogobar && this.IntranetView){
          logobar.style.display = 'none'
          belowlogobar.style.top = '30px'
        }
        if(recordtoolbar){
        recordtoolbar.style.top = '50px'
        }
        if(recordtoolbar2){
        recordtoolbar2.style.top = '70px'
        }
        if(recordownershipbanner1){
        recordownershipbanner1.style.top = '110px'
        }
        if(recordownershipbanner2){
        recordownershipbanner2.style.top = '110px'
        }
      }
      else {
        if(logobar && belowlogobar && this.IntranetView){
          logobar.style.display = 'block'
          belowlogobar.style.top = "100px"
        }
        if(recordtoolbar){
        recordtoolbar.style.top = '100px'
        }
        if(recordtoolbar2){
        recordtoolbar2.style.top = '100px'
        }
        if(recordownershipbanner1){
        recordownershipbanner1.style.top = '160px'
        }
        if(recordownershipbanner2){
        recordownershipbanner2.style.top = '160px'
        }
      }
    },
    async CheckAuth(){
      let vm = this
    await firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.SignedIn = true
          db.collection('users').doc(user.uid).onSnapshot(snapshot => {
            let userdata = snapshot.data()
            vm.UserRecord = userdata
            vm.UserRecord.id = user.uid
          })
          console.log('seeing signed in')
        }
        else{
          vm.SignedIn = false
          console.log('seeing as NOT signed in')
        }
    })
  },
  }
}
</script>
<style>
.announcementpulse{
  animation: announcepulse 2s infinite;
}
@keyframes announcepulse {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(230, 196, 5, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(211, 197, 3, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}

}
.BGImage{
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.centertext {
text-align:center;
}
.slightmargin{
  padding: 25px;
}
.elevatedsectionheader{
  z-index: 2;
  box-shadow: 0 2px 8px 0 rgb(100, 100, 100);
}
.overlayed{
  margin-top: -60px;
}
.stickytopconscious{
  top: 110px
}
.recordparallax{
  top: 160px;
}
.recordparallax2{
  top: 50px;
}
.pagetop{
  top: 50px;
}
.breadcrumbstop{
  top: 50px;
  z-index: 1;
}
.stickytopright {
  position: fixed;
  top: 100px;
  right: 10px;
  z-index: 4
}
.stickytopleft {
  position: fixed;
  top: 100px;
  left: 50px;
  z-index: 4
}
.stickytopbanner2{
  position: fixed;
  top: 100px;
  z-index: 4
}
.stickytopbanner3{
  position: fixed;
  top: 160px;
  z-index: 4
}
.stickytopbanner4{
  position: fixed;
  top: 220px;
  z-index: 4
}
.leftpadded{
   right: 40px;
}
.footermargin{  
 
  padding-bottom: 150px;
}

.focusedviewborder{
  border: solid;
  border-width: 50px;
}
.incompletedmandatory{
  border: red;
  color: white;
  font-size: 20px;
  animation: pulse 2s infinite;
}
@keyframes pulse {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
}

progress[value] {
  /* Reset the default appearance */
  -webkit-appearance: none;
   appearance: none;

  width: 250px;
  height: 20px;
}
progress[value]::-webkit-progress-bar {
  background-color: #eee;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}
progress[value]::-webkit-progress-value {
  background:
	   -webkit-linear-gradient(-45deg, 
	                           transparent 33%, rgba(0, 0, 0, .1) 33%, 
	                           rgba(0,0, 0, .1) 66%, transparent 66%),
	   -webkit-linear-gradient(top, 
	                           rgba(255, 255, 255, .25), 
	                           rgba(0, 0, 0, .25)),
	   -webkit-linear-gradient(left, #87B6E6, #141A1F);

    border-radius: 2px; 
    background-size: 35px 20px, 100% 100%, 100% 100%;
    -webkit-animation: animate-stripes 5s linear infinite;
        animation: animate-stripes 5s linear infinite;
}
@-webkit-keyframes animate-stripes {
   0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes animate-stripes {
   0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
h2{
  color: black;
}
.txtlink {
    color: rgb(253, 253, 253);
    text-decoration: none;
    font-size: 16px;
}
</style>
    